import axios from 'axios';
import {apiBaseUrl} from '../../../helpers/UrlHelper'
import {handleError} from "../../../helpers/ErrorHelper";
import {loginToken} from "../../../helpers/LocalStorageHelper";

function _success(success) {
  return{ type: 'GETS_CACHE_IGNORE_SUCCESS',success };
}
function _error(error) {
  return{ type: 'GETS_CACHE_IGNORE_ERROR',error };
}
function _processing(processing) {
  return{ type: 'GETS_CACHE_IGNORE_PROCESSING', processing };
}

function getsCacheIgnore(site_id,org_id) {
  return ( dispatch ) => {
    dispatch(_processing(true));
    dispatch(_error(null));

      axios({
        url: apiBaseUrl(`admin/organizations/${org_id}/sites/${site_id}/tools/cache/ignore`),
        method: "get",
        dataType: 'json',
        headers: {
          'Authorization': 'Bearer ' + loginToken()
        }
      }).then(function (res) {
        dispatch(_processing(false));
        dispatch(_success(res));

      }).catch(function (error) {
        handleError(error);
        dispatch(_error(error));
        dispatch(_processing(false));
      });
    }
}
export default getsCacheIgnore;
